import axios from 'axios';

const INBOUND_BASE = process.env.REACT_APP_INBOUND_API_BASE || 'http://localhost:8004';

const inboundApi = axios.create({
  baseURL: `${INBOUND_BASE}/api`,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

// Redirect to login on 401 (skip for /auth/me — handled by AuthContext)
inboundApi.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401 && !err.config?.url?.includes('/auth/me')) {
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default inboundApi;
